export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8845.fcf1a908.jpg";